import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { verifyInvitation, acceptReplaceInvitation, declineReplaceInvitation } from '../../api/api'
import "../landingPage/landingPage";

export default function ReplacePage() {

    const { replaceString } = useParams();
    console.log("replaceString", replaceString);

    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [validToken, setValidToken] = useState(false);
    const [tokenLoader, setTokenLoader] = useState(false);

    useEffect(() => {

        verifyInviteToken(replaceString);

    }, []);


    const verifyInviteToken = async (replaceString) => {

        try {
            const { status, message } = await verifyInvitation(replaceString);
            console.log('verifyInviteToken API Response:', status, message);
            if (status) {
                setValidToken(true);
                setTimeout(() => {
                    setTokenLoader(true);
                }, 2000);
            } else {
                setErrorMessage(message || 'Invalid token.');
            }
        } catch (error) {
            console.error('verifyInviteToken Error:', error);
            setErrorMessage(error.message || 'Something went wrong.');
        }
    };

    const handleAcceptSubmit = async () => {
        const { status, message } = await acceptReplaceInvitation(replaceString)
        if (status) {
            console.log('handleAcceptSubmit res', status, message)
            messageShowHandler("Invitation accepted successfully");
        }

    }

    const handleDeclineSubmit = async () => {
        const { status, message } = await declineReplaceInvitation(replaceString)
        if (status) {
            console.log('handleDeclineSubmit res', status, message)
            messageShowHandler("Invitation Declined successfully!");

        }
    }


    const messageShowHandler = (msgText) => {
        navigate("/response", { state: msgText });
    }

    return (
        <div className='landingPage'>
            {
                !tokenLoader &&
                <div className="loaderContainer">
                    {validToken ? (
                        <h2>Link Verified Successfully</h2>
                    ) : errorMessage ? (
                        <h2 className="error">{errorMessage}</h2>
                    ) : (
                        <span className="loaderAnimation">Loading...</span>
                    )}
                </div>
            }
            <div className='landingContentPart'>
                <h3 className='headingtext'>
                    Replace Process Initiated – Awaiting Your Response.
                </h3>
                <p className='paraText'>
                    You’ve been invited to participate in the Replace process. Click ‘Accept’ to continue or ‘Decline’ if you choose not to proceed.
                </p>
                <div className='btnWrapper'>
                    <button className='primaryBtn' onClick={handleAcceptSubmit}>Accept</button>
                    <button className='cancelBtn' onClick={handleDeclineSubmit}>Decline</button>
                </div>
            </div>
        </div>
    )
}
